import React,{useEffect,useState} from 'react';
import {Link} from 'react-router-dom';
import {Tv,ArrowLeft} from 'lucide-react';
import {api,useAuth} from '../context/AuthContext';
import {useLocale} from '../context/LocaleContext';
import {broadcastCopy} from '../context/broadcastCopy';
import PrivateLivePlayer from './PrivateLivePlayer';
export default function LiveBroadcast(){
 const {t,locale}=useLocale(),copy=broadcastCopy[locale]||broadcastCopy.tr;
 const {user}=useAuth();
 const [state,setState]=useState(null),[failed,setFailed]=useState(false),[attempt,setAttempt]=useState(0);
 useEffect(()=>{
  let alive=true,controller;setState(null);setFailed(false);
  const refresh=async()=>{controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),12000);
   try{const response=await api.get('/live-broadcast',{signal:controller.signal});const data=response.data;
    if(typeof data.active!=='boolean'||(data.active&&!/^\/api\/live-media\/[a-f0-9]{64}$/.test(data.manifest_path||'')))throw new Error();
    if(alive){setState(data);setFailed(false)}
   }catch{if(alive)setFailed(true)}finally{clearTimeout(timeout)}};
  refresh();const timer=setInterval(refresh,30000);
  return()=>{alive=false;controller?.abort();clearInterval(timer)};
 },[attempt,user?.user_id]);
 return <main className="mx-auto max-w-5xl px-4 py-8 sm:px-8" style={{color:'var(--sy-text)'}}>
  <Link to="/" className="inline-flex items-center gap-2 text-sm"><ArrowLeft size={14}/>{t('Ana Sayfa')}</Link>
  <h1 className="mt-6 font-display text-4xl sy-gold-text">{t('Canlı Yayın')}</h1>
  <p className="mt-3 mb-7" style={{color:'var(--sy-text-dim)'}}>{copy[0]}</p>
  <section className="overflow-hidden rounded-2xl border" style={{borderColor:'var(--sy-border)',background:'#050e0b'}} aria-label={t('Canlı Yayın')}>
   {state?.active&&!failed?<PrivateLivePlayer path={state.manifest_path}/>:
   <div className="flex aspect-video min-h-56 flex-col items-center justify-center gap-5 px-6 text-center" role="status">
    <Tv size={68} strokeWidth={1} style={{color:'var(--sy-gold)'}} aria-hidden="true"/>
    <p>{failed?copy[3]:state?copy[1]:copy[2]}</p>
    {failed&&<button onClick={()=>setAttempt(x=>x+1)} className="rounded-full border px-5 py-2">{copy[4]}</button>}
   </div>}
  </section>
 </main>;
}
